import React, { useEffect, useRef } from "react";
import {
  BrowserRouter,
  Route,
  Router,
  Routes,
  useNavigate,
} from "react-router-dom";
import { APP_ROUTES } from "./pageRoutes";
import Home from "../Pages/Home";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import TermsOfUse from "../Pages/TermsOfUse";
import RefundPolicy from "../Pages/RefundPolicy";
import ConsultDoctor from "../Pages/BookAppointment/ConsultDoctor";
import BookConsultant from "../Pages/BookAppointment/BookConsultant";
import Checkout from "../Pages/BookAppointment/Checkout";
// newly added page imports from patient app
import VideoCall from "../Pages/VideoConsultation";
import MedicaHistory from "../Pages/MedicalRecords/MedicaHistory";
import MyPresctription from "../Pages/MedicalRecords/MyPrescription";
import MyVitals from "../Pages/MedicalRecords/MyVitals/MyVitals";
import MyReports from "../Pages/MedicalRecords/MyReports";
import ForgotPassword from "../Authentication/ForgotPassword";
import Sharecallpatient from "../Pages/VideoConsultation/Sharecallpatient";
import PaymentPage from "../Pages/PaymentInitiation";
// import SharePrescription from "../Pages/MedicalRecords/MyPrescription/SharePrescription";
import LabPrescription from "../Pages/MedicalRecords/MyPrescription/LabPrescription";
import PharmacyPrescription from "../Pages/MedicalRecords/MyPrescription/PharmacyPrescription";
import PrescriptionTemplate from "../Pages/MedicalRecords/MyPrescription/PrescriptionTemplate";
import MyLabReports from "../Pages/MedicalRecords/MyLabReports";
import MyAppointments from "../Pages/MyAppointments";
import MyProfile from "../Pages/MyProfile";
import MedicalRecords from "../Pages/MedicalRecords";
import Payments from "../Pages/Payments";
import Settings from "../Pages/Settings";
import FamilyMembers from "../Pages/FamilyMembers";
import HealthSummary from "../Pages/HealthSummary";
import PHRACCESS from "../Pages/HealthSummary/PhrAccess";
import HospitalService from "../Pages/HospitalService";
import Consent from "../Pages/Consent/Consent";
import DashboardNew from "../Pages/DashboardNew/DashboardNew";
import OrderHistory from "../Pages/OrderHistory";
import GiveConsent from "../DirectLinkPages/GiveConsent";
import BookLabtest from "../Pages/BookLabTest";
import BookMedicines from "../Pages/BookMedicine";
import MedicineDetails from "../Pages/BookMedicine/medicineDetails";
import LabTestDetails from "../Pages/BookLabTest/TestDetails";
import Cart from "../Pages/Cart";
import SharePrescription from "../DirectLinkPages/Prescription";
import LabReportLink from "../DirectLinkPages/LabReportLink";
import SharePaymentLink from "../DirectLinkPages/SharePaymentLink";
import ShareCall from "../DirectLinkPages/ShareCall";
import Notification from "../Pages/Notifications";
import PatientDevices from "../Pages/Devices";
import Membership from "../Pages/Membership";
import JoinMembership from "../Pages/Membership/JoinMembership";
import {
  clearLoggedUser,
  deleteDataFromLocal,
} from "../Redux/actions/AuthActions";
import { useDispatch } from "react-redux";
import MobileConsent from "../DirectLinkPages/MobileConsent";
import ProcedureList from "../Pages/Procedure";
import { clearSelectedAppt } from "../Redux/actions/appointmentActions";
import DietPlan from "../Pages/DietPlan";
import BookingDemo from "../Pages/BookingDemo";
import MedicineReminder from "../Pages/MedicineReminder";
import Blog from "../DoxzonNew/Blog";
import BlogDetail from "../DoxzonNew/BlogDetail";
import AbhaRegistration from "../DoxzonNew/Abharegistration";
import PrivacyPolicyContent from "../Pages/PolicyContents/PrivacyPolicyContent";
import TermsAndConContent from "../Pages/PolicyContents/TermsAndConContent";
import RefundPolicyContent from "../Pages/PolicyContents/RefundPolicyContent";
import DoctorEnrollmentForm from "../Pages/UserRequestForm/doctorEnrollmentForm";
import RPMEnrollmentForm from "../Pages/UserRequestForm/RPMEnrollmentForm";

// footercontent
// platform
import Telemedicine from "../DoxzonNew/footercontent/Platform/Telemedicine";
import HealthRecords from "../DoxzonNew/footercontent/Platform/HealthRecords";
import Diagnostics from "../DoxzonNew/footercontent/Platform/Diagnostics";
import Integrations from "../DoxzonNew/footercontent/Platform/Integrations";

// patient
import FindCare from "../DoxzonNew/footercontent/Patient/FindCare";
import Appointments from "../DoxzonNew/footercontent/Patient/Appointments";
import LabTest from "../DoxzonNew/footercontent/Patient/LabTests";
import FamilyCare from "../DoxzonNew/footercontent/Patient/FamilyCare";
import Pharmacy from "../DoxzonNew/footercontent/Patient/Pharmacy";

//Healthcare Professionals
import EHR from "../DoxzonNew/footercontent/Healthcare_Professionals/EHR";
import Scheduling from "../DoxzonNew/footercontent/Healthcare_Professionals/Scheduling";
import EPrescription from "../DoxzonNew/footercontent/Healthcare_Professionals/Eprescription";
import Billing from "../DoxzonNew/footercontent/Healthcare_Professionals/Billing";
import VirtualCare from "../DoxzonNew/footercontent/Healthcare_Professionals/VirtualCare";

//company
import Contact from "../DoxzonNew/footercontent/Company/Contact";
import Careers from "../DoxzonNew/footercontent/Company/Careers";
import Press from "../DoxzonNew/footercontent/Company/Press";
import AboutDoxzon from "../DoxzonNew/footercontent/Company/AboutDoxzon";
import Partners from "../DoxzonNew/footercontent/Company/Partners";

import HelpCenter from "../DoxzonNew/footercontent/Trust/HelpCenter";
import Security from "../DoxzonNew/footercontent/Trust/SecurityPrivacy";
import SystemStatus from "../DoxzonNew/footercontent/Trust/SystemStatus";
import Compliance from "../DoxzonNew/footercontent/Trust/Compliance";

export const PageRoutes = () => {
  const navigate = useNavigate();
  const idleTimerRef = useRef(null);
  const dispatch = useDispatch();

  const handleIdle = () => {
    sessionStorage.clear();
    sessionStorage.clear();
    if ("caches" in window) {
      caches.keys().then((names) => {
        for (let name of names) {
          caches.delete(name);
        }
      });
    }
    dispatch(deleteDataFromLocal());
    dispatch(clearLoggedUser(null));
    dispatch(clearSelectedAppt(null));
    navigate("/");
  };

  useEffect(() => {
    const resetTimer = () => {
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
      idleTimerRef.current = setTimeout(handleIdle, 7200000);
    };
    const events = ["mousemove", "keydown", "scroll", "click"];
    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();
    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    };
  }, []);

  return (
    <Routes>
      <Route path={APP_ROUTES.BLOG} element={<Blog />} />
      <Route path={APP_ROUTES.BLOGDETAIL} element={<BlogDetail />} />
      <Route
        path={APP_ROUTES.PATIENTREGISTRATION}
        element={<AbhaRegistration />}
      />
      <Route path={APP_ROUTES.LOGIN} element={<Home />} />
      <Route path={APP_ROUTES.PRIVACYPOLICY} element={<PrivacyPolicy />} />
      <Route path={APP_ROUTES.TERMSOFUSE} element={<TermsOfUse />} />
      <Route path={APP_ROUTES.REFUNDPOLICY} element={<RefundPolicy />} />
      <Route path={APP_ROUTES.CONSULTDOCTOR} element={<ConsultDoctor />} />
      <Route path={APP_ROUTES.DOCTORDETAILS} element={<BookConsultant />} />
      <Route path={APP_ROUTES.CHECKOUT} element={<Checkout />} />
      <Route path={APP_ROUTES.PRIVACYPOLICY} element={<PrivacyPolicy />} />
      {/* newly added pages from patient app */}
      <Route
        exact
        path={APP_ROUTES.SHARECALLPATIENT}
        element={<Sharecallpatient />}
      />
      <Route path={APP_ROUTES.MYAPPOINMENTS} element={<MyAppointments />} />
      <Route path={APP_ROUTES.MYPROFILE} element={<MyProfile />} />
      <Route path={APP_ROUTES.MEDICALRECORDS} element={<MedicalRecords />} />
      <Route path={APP_ROUTES.MEDICALHISTORY} element={<MedicaHistory />} />
      <Route path={APP_ROUTES.MYPRESCRIPTION} element={<MyPresctription />} />
      <Route path={APP_ROUTES.LABPRSCRIPTION} element={<LabPrescription />} />
      <Route
        path={APP_ROUTES.PHARMACYPRSCRIPTION}
        element={<PharmacyPrescription />}
      />
      <Route path={APP_ROUTES.MYVITALS} element={<MyVitals />} />
      <Route path={APP_ROUTES.MYREPORTS} element={<MyReports />} />
      <Route path={APP_ROUTES.MYLABREPORTS} element={<MyLabReports />} />
      <Route path={APP_ROUTES.PAYMENTS} element={<Payments />} />
      <Route path={APP_ROUTES.VIDEOCALL} element={<VideoCall />} />
      <Route path={APP_ROUTES.FORGOTPASSWORD} element={<ForgotPassword />} />
      <Route
        path={APP_ROUTES.PrescriptionTemplate}
        element={<PrescriptionTemplate />}
      />
      <Route
        path={APP_ROUTES.DOCTORENROLLMENTFORM}
        element={<DoctorEnrollmentForm />}
      />
      <Route
        path={APP_ROUTES.RPMENROLLMENTFORM}
        element={<RPMEnrollmentForm />}
      />
      <Route path={APP_ROUTES.PHONEPEPAYMENT} element={<PaymentPage />} />
      <Route path={APP_ROUTES.SETTINGS} element={<Settings />} />
      <Route path={APP_ROUTES.FAMILYMEMBERS} element={<FamilyMembers />} />
      <Route path={APP_ROUTES.PHRACCESS} element={<PHRACCESS />} />
      <Route path={APP_ROUTES.HEALTHSUMMARY} element={<HealthSummary />} />
      <Route path={APP_ROUTES.HOSPITALSERVICE} element={<HospitalService />} />
      <Route path={APP_ROUTES.MEDICINES} element={<BookMedicines />} />
      <Route path={APP_ROUTES.LABTESTS} element={<BookLabtest />} />
      <Route path={APP_ROUTES.CONSENT} element={<Consent />} />
      <Route path={APP_ROUTES.DASHBOARDNEW} element={<DashboardNew />} />
      <Route path={APP_ROUTES.ORDERHISTORY} element={<OrderHistory />} />
      <Route path={APP_ROUTES.GIVECONSENT} element={<GiveConsent />} />
      <Route path={APP_ROUTES.BOOKMEDICINE} element={<BookMedicines />} />
      <Route path={APP_ROUTES.BOOKLABTEST} element={<BookLabtest />} />
      <Route path={APP_ROUTES.MEDICINEDETAILS} element={<MedicineDetails />} />
      <Route path={APP_ROUTES.LABTESTDETAILS} element={<LabTestDetails />} />
      <Route path={APP_ROUTES.CART} element={<Cart />} />
      <Route path={APP_ROUTES.NOTIFICATION} element={<Notification />} />
      <Route path={APP_ROUTES.DEVICES} element={<PatientDevices />} />
      <Route path={APP_ROUTES.PROCEDURELIST} element={<ProcedureList />} />
      <Route
        path={APP_ROUTES.MEDICINEREMINDER}
        element={<MedicineReminder />}
      />
      <Route path={APP_ROUTES.DIETPLAN} element={<DietPlan />} />
      <Route path={APP_ROUTES.BOOKDEMO} element={<BookingDemo />} />
      <Route path={APP_ROUTES.MEMBERSHIP} element={<Membership />} />
      <Route path={APP_ROUTES.JOINMEMBERSHIP} element={<JoinMembership />} />

      {/* Direct Link Components */}
      <Route
        path={APP_ROUTES.SHAREPRSCRIPTION}
        element={<SharePrescription />}
      />
      <Route
        path={APP_ROUTES.DOCTORENROLLMENTFORM}
        element={<DoctorEnrollmentForm />}
      />
      <Route
        path={APP_ROUTES.RPMENROLLMENTFORM}
        element={<RPMEnrollmentForm />}
      />
      <Route
        path={APP_ROUTES.SHAREPAYMENTLINK}
        element={<SharePaymentLink />}
      />
      <Route path={APP_ROUTES.SHARECALL} element={<ShareCall />} />
      <Route path={APP_ROUTES.LABREPORTLINK} element={<LabReportLink />} />

      <Route path={APP_ROUTES.MOBILECONSENT} element={<MobileConsent />} />

      {/* Doxzon privacy and terms direct links */}
      <Route
        path={APP_ROUTES.DOXPRIVACYPOLICY}
        element={<PrivacyPolicyContent />}
      />
      <Route path={APP_ROUTES.DOXTERMSOFUSE} element={<TermsAndConContent />} />
      <Route
        path={APP_ROUTES.DOXREFUNDPOLICY}
        element={<RefundPolicyContent />}
      />

      {/* Footer content routes */}
      <Route path={APP_ROUTES.TELEMEDICINE} element={<Telemedicine />} />
      <Route path={APP_ROUTES.HEALTHRECORDS} element={<HealthRecords />} />
      <Route path={APP_ROUTES.DIAGNOSTICS} element={<Diagnostics />} />
      <Route path={APP_ROUTES.INTEGRATIONS} element={<Integrations />} />

      {/* Footer content routes for patient */}
      <Route path={APP_ROUTES.FINDCARE} element={<FindCare />} />
      <Route path={APP_ROUTES.APPOINTMENTS} element={<Appointments />} />
      <Route path={APP_ROUTES.LABTEST} element={<LabTest />} />
      <Route path={APP_ROUTES.FAMILYCARE} element={<FamilyCare />} />
      <Route path={APP_ROUTES.PHARMACY} element={<Pharmacy />} />

      {/* Footer content routes for Healthcare Professionals */}
      <Route path={APP_ROUTES.EHR} element={<EHR />} />
      <Route path={APP_ROUTES.SCHEDULING} element={<Scheduling />} />
      <Route path={APP_ROUTES.EPRESCRIPTION} element={<EPrescription />} />
      <Route path={APP_ROUTES.BILLING} element={<Billing />} />
      <Route path={APP_ROUTES.VIRTUALCARE} element={<VirtualCare />} />

      {/* Footer content routes for company */}
      <Route path={APP_ROUTES.CONTACT} element={<Contact />} />
      <Route path={APP_ROUTES.CAREERS} element={<Careers />} />
      <Route path={APP_ROUTES.PRESS} element={<Press />} />
      <Route path={APP_ROUTES.ABOUTDOXON} element={<AboutDoxzon />} />
      <Route path={APP_ROUTES.PARTNERS} element={<Partners />} />

      {/* Footer content routes for Trust */}
      <Route path={APP_ROUTES.HELPCENTER} element={<HelpCenter />} />
      <Route path={APP_ROUTES.SECURITY} element={<Security />} />
      <Route path={APP_ROUTES.SYSTEMSTATUS} element={<SystemStatus />} />
      <Route path={APP_ROUTES.COMPLIANCE} element={<Compliance />} />
    </Routes>
  );
};
